import React, { useEffect } from "react";
import "./App.css";
import { CosmoComponent } from "./cosmo-graph/cosmo-component";
import { DataGroup, LinkType, NodeType, SharedDataType } from "./cosmo-graph/model";
import { CosmographProvider } from "@cosmograph/react";
import { fetchData, GraphContext, updateNodesData } from "./cosmo-graph/data";
import { ClusterPanel } from "./cosmo-graph/cluster-panel";
import { NotePanel } from "./cosmo-graph/node-panel";
import { CrPanel } from "./cosmo-graph/cr-panel";
import { SearchPanel } from "./cosmo-graph/search-panel";
import { AboutPanel } from "./cosmo-graph/about-panel";
import { RangePanel } from "./cosmo-graph/range-panel";

async function decompressBlob(jsonGz: string) {
  const response = await fetch(jsonGz);
  if (response && response.body) {
    const ds = new (window as any).DecompressionStream("gzip");
    const decompressed_stream = response.body.pipeThrough(ds);
    const decompressed_text = await new Response(decompressed_stream).text();
    const json = JSON.parse(decompressed_text);
    return json;
  }
  return null;
}

function App() {
  const [nodes, setNodes] = React.useState<NodeType[]>([]);
  const [links, setLinks] = React.useState<LinkType[]>([]);
  const [sharedData, setSharedData] = React.useState<SharedDataType>({
    source: "",
    subType: "",
  });
  useEffect(() => {
    const updateData = async () => {
      // const nodesUrl = "data/002.node_label.tsv";
      // const linksUrl = "data/001.network.tsv";
      // const nodesData = await fetchData(nodesUrl, DataGroup.NODE);
      // const linksData = await fetchData(linksUrl, DataGroup.LINK);
      // const colors = updateNodesData(
      //   nodesData.nodes as NodeType[],
      //   linksData.nodes as LinkType[]
      // );
      // setNodes(nodesData.nodes as NodeType[]);
      // setLinks(linksData.nodes as LinkType[]);
      // setColorList(colors);
      // console.log("colors", colors, "nodes:", nodesData.nodes, "links:", linksData.nodes);
      const jsonGz = "data/json.gz";
      const jsonData = await decompressBlob(jsonGz);
      setNodes(jsonData.nodes as NodeType[]);
      setLinks(jsonData.links as LinkType[]);
      setColorList(jsonData.colors);
      setRangeList(jsonData.rangeData);
      // console.log(
      //   "colors",
      //   jsonData.colors,
      //   ", nodes:",
      //   jsonData.nodes,
      //   ", links:",
      //   jsonData.links
      // );
    };
    updateData();
  }, []);

  const [clusterData, setClusterData] = React.useState<any>({});
  const [nodeData, setNodeData] = React.useState<any>({});
  const [colorList, setColorList] = React.useState<any>([]);
  const [rangeList, setRangeList] = React.useState<any>([]);
  return (
    <div className="root-container">
      <GraphContext.Provider
        value={{
          clusterData,
          setClusterData,
          nodeData,
          setNodeData,
          sharedData,
          setSharedData,
          colorList,
          setColorList,
          rangeList,
          setRangeList,
        }}
      >
        <CosmographProvider nodes={nodes} links={links}>
          <CosmoComponent />
        </CosmographProvider>
        <SearchPanel nodes={nodes} links={links} />
        <ClusterPanel />
        <NotePanel />
        <RangePanel />
        <CrPanel side="left" />
        <CrPanel side="right" />
        <AboutPanel />
      </GraphContext.Provider>
    </div>
  );
}

export default App;
